import { Injectable } from '@angular/core';
import { WebSocketService } from './web-socket.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, switchMap, take, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { selectSession, SessionActions } from '@state/session';
import { WebSocketMappings } from './web-socket.mapper';
import { WebSocketActions } from './web-socket.actions';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { environment } from '@environment/environment';

@Injectable({
	providedIn: 'root',
})
export class WebSocketServiceEffects {
	constructor(
		private readonly webSocketService: WebSocketService,
		private readonly actions$: Actions<any>,
		private readonly store: Store
	) {}

	createConnection$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(ROUTER_NAVIGATED),
				filter(() => !!environment.webSocket.enabled),
				switchMap(() => this.store.select(selectSession).pipe(take(1))),
				filter((session) => !!session.loggedIn),
				tap(() => this.webSocketService.connect())
			),
		{ dispatch: false }
	);

	setAccount$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(WebSocketActions.connect),
				filter(() => !!environment.webSocket.enabled),
				switchMap(() => this.store.select(selectSession).pipe(take(1))),
				filter((session) => !!session.loggedIn),
				tap((session) =>
					this.webSocketService.sendMessage(
						WebSocketMappings.setAccountPayload(session.data.user.id, session.data.account.id)
					)
				)
			),
		{ dispatch: false }
	);

	closeConnection$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(SessionActions.logout.start, SessionActions.login.setup.success),
				filter(() => !!environment.webSocket.enabled),
				tap((action) =>
					this.webSocketService.close(action.type === SessionActions.login.setup.success.type)
				)
			),
		{ dispatch: false }
	);
}
